import { useSelector } from "react-redux"
import { useMutation } from "@tanstack/react-query"

import { API_C2C_URL } from "../constants"
import { ICreateSbpOutcomeTransferRequest, ICreateSbpOutcomeTransferResponse } from "../interface"
import { RootState } from "../../store/store"
import { axios } from "../axios"

async function create(token: string | null, request: ICreateSbpOutcomeTransferRequest) {
  const response = await axios(API_C2C_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: request,
  })
  // TODO: добавить обработку ошибок
  return response.data
}

export const useCreateSbpOutcomeTransfer = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useMutation<ICreateSbpOutcomeTransferResponse, string, ICreateSbpOutcomeTransferRequest>({
    mutationFn: (req) => create(token, req),
  })
}
